import React from 'react';

const AsyncMonitoringList = React.lazy(() => import('./ListContainer'));

export const MonitoringList = () => {
  return <AsyncMonitoringList />;
};
